import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function H3Icon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.75 7C6.16421 7 6.5 7.33579 6.5 7.75V11.5H10.5V7.75C10.5 7.33579 10.8358 7 11.25 7C11.6642 7 12 7.33579 12 7.75V16.25C12 16.6642 11.6642 17 11.25 17C10.8358 17 10.5 16.6642 10.5 16.25V13H6.5V16.25C6.5 16.6642 6.16421 17 5.75 17C5.33579 17 5 16.6642 5 16.25V7.75C5 7.33579 5.33579 7 5.75 7ZM14.2601 7.70207C14.7716 7.26095 15.4609 7 16.205 7C17.6344 7 19 8.01447 19 9.5V10C19 10.8212 18.6176 11.5148 18.0341 12C18.6176 12.4852 19 13.1788 19 14V14.5C19 15.9855 17.6344 17 16.205 17C15.4609 17 14.7716 16.739 14.2601 16.2979C13.9465 16.0274 13.9115 15.5538 14.1821 15.2401C14.4526 14.9265 14.9262 14.8915 15.2399 15.1621C15.4704 15.361 15.8091 15.5 16.205 15.5C17.0336 15.5 17.5 14.9465 17.5 14.5V14C17.5 13.4147 16.9029 12.75 15.913 12.75H15.329C14.9148 12.75 14.579 12.4142 14.579 12C14.579 11.5858 14.9148 11.25 15.329 11.25H15.913C16.9029 11.25 17.5 10.5853 17.5 10V9.5C17.5 9.05353 17.0336 8.5 16.205 8.5C15.8091 8.5 15.4704 8.63905 15.2399 8.83793C14.9262 9.10847 14.4526 9.07351 14.1821 8.75986C13.9115 8.4462 13.9465 7.97261 14.2601 7.70207Z"
        fill="currentColor"
      />
    </svg>
  );
};
